var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107 104V84c0-1.7-1.3-3-3-3s-3 1.3-3 3v17H27V84c0-1.7-1.3-3-3-3s-3 1.3-3 3v20c0 1.7 1.3 3 3 3h80C105.7 107 107 105.7 107 104zM64 21c-1.7 0-3 1.3-3 3v42.8l-9.9-9.9c-1.2-1.2-3.1-1.2-4.2 0-1.2 1.2-1.2 3.1 0 4.2l15 15c.6.6 1.4.9 2.1.9s1.5-.3 2.1-.9l15-15c1.2-1.2 1.2-3.1 0-4.2-1.2-1.2-3.1-1.2-4.2 0L67 66.8V24C67 22.3 65.7 21 64 21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4ee66b0ce1466d99fdd5158fce9f3a11.svg";
export { ForwardRef as ReactComponent };